export default __webpack_public_path__ + "static/media/Web 1280 ΓÇô 19.9244c3b9.jpg";